// extracted by css-extract-rspack-plugin
export default {"groupNode":"DisplayGroupNode_groupNode__N8Swr","selected":"DisplayGroupNode_selected__RSF+J","label":"DisplayGroupNode_label__Rc0ZG"};